module.exports = __webpack_public_path__ + "static/red_dragon_at_hoard-12939f837dd871ae5f3c6f4c64c83c8a.jpg";